<template>
  <div>
    <h1 class="page-title">{{ $t("catalogue.products.title") }}</h1>
  </div>
    <div class="flex justify-end ml-auto mb-3">
        <Button
            @click="navigateToAddProduct"
            label="Ajouter un produit"
            icon="pi pi-plus"
            class="button-add"
        />
    </div>
  <div class="card">
    <DataTable
      :value="tableData"
      :rows="rows"
      :loading="isLoading"
      :rowsPerPageOptions="rowsPerPageOptions"
      :globalFilterFields="['properties.adminProductName.value']"
      :totalRecords="totalRecords"
      :currentPage="currentPage"
      :rowHover="true"
      :selectAll="isSelectAllBtnChecked"
      lazy
      paginator
      @page="onPaginate"
      v-model:selection="selectedProducts"
      @select-all-change="onSelectAllChange($event)"
      @row-select="onRowSelect()"
      @row-unselect="onRowUnselect()"
      stateStorage="local"
      :state-key="localStorageKey"
    >
      <template #header>
        <div class="search-container">
            <div class="flex w-full top">
                <div>
                    <span class="p-input-icon-left mb-5">
                    <i class="pi pi-search" />
                       <InputText
                           v-model="criteria"
                           @keyup.enter="onFilterDt"
                           placeholder="Rechercher un produit"
                           @input="onClearInputFilter"
                       />
                  </span>
               <br>
                    <FormKit
                        type="autocomplete"
                        label=""
                        name="supplier"
                        placeholder="Sélectionner un fournisseur"
                        :options="searchSuppliers"
                        v-model="selectedOptionSupplier"
                    />
                </div>          

                
            </div>
        </div>

          <div class="w-full search-container">
              <div class="card-toolbar w-50 flex-none">
                  <FormKit type="form"
                       #default="{ state: { valid } }"
                       :actions="false"
                       @submit="onSubmit"
                  >
                      <div class="flex flex-row align-items-center">
                          <FormKit
                              type="select"
                              name="selected_status_for_batch_update"
                              v-model="selectedStatusOptionForBatchUpdate"
                              :options="[
                                { label: 'Changer de statut', value: null },
                                { label: 'Activé', value: true },
                                { label: 'Désactivé', value: false },
                            ]"
                          />
                          <div class="card-actions ml-3">
                              <div v-if="!isLoading">
                                  <FormKit type="submit" label="Appliquer" :disabled="!valid || totalSelectedProducts <= 0 || selectedStatusOptionForBatchUpdate === null"/>
                              </div>
                          </div>
                      </div>
                  </FormKit>

                  
                     
                  
              </div>             
          </div>
          <div class="flex ml-auto w-full justify-end">
              <div>Nombre de ligne sélectionnée(s) : {{ totalSelectedProducts }} produit(s)</div>
          </div>
      </template>
      <div class="card-body p-0">
        <Column selectionMode="multiple"></Column>
        <Column
          field="properties.adminProductName.value"
          header="Nom du produit"
          filterField="properties.adminProductName.value"
        />
        <Column field="prototype.value" header="Type de produit" />
        <Column field="specialProperties.brand.value" header="Marque" />
        <Column field="supplier.value" header="Fournisseur" />
        

          <Column field="status" header="Statut">
              <template #body="slotProps">
                  <div v-if="slotProps.data.status?.active" class="badge border-white text-green-800 bg-green-200 p-4">
                      Activé
                  </div>
                  <div v-else class="badge border-white text-red-800 bg-red-200 p-4">
                      Désactivé
                  </div>
                  <div v-if="slotProps.data.status?.hiddenProduct" class="badge border-white text-orange-800 bg-orange-200 p-4 ml-2">
                      Masqué
                  </div>
                  <div v-if="slotProps.data.status?.closedSale" class="badge border-white text-purple-800 bg-purple-200 p-4 ml-2">
                      Vente fermée
                  </div>
              </template>
          </Column>

          <Column headerStyle="width: 14em;" class=" whitespace-nowrap">
          <template #header>
            <div>Actions</div>
          </template>
          <template #body="slotProps">
            <router-link :to="{ name: 'EditProduct', params: { uuid: slotProps.data.uuid }}">
              <Button
                size="small"
                icon="pi pi-pencil"
                class="p-edition"
                :class="`${slotProps.data.uuid}`"
                style="margin-right: 0.5em"
                title="Éditer"

              >
              </Button>
            </router-link>
            <Button
              size="small"
              icon="pi pi-trash"
              class="p-button-danger"
              style="margin-right: 0.5em"
              title="Supprimer"
              @click="onDelete(slotProps.data)"
            >
            </Button>
            <router-link :to="{ name: 'listProductVariants', params: { uuid: slotProps.data.uuid }}">
              <Button
                size="small"
                icon="pi pi-eye"
                class="p-button-info p-button-eye"
                :class="`${slotProps.data.uuid}`"
                style="margin-right: 0.5em"
                title="Voir les variants"
                v-if="slotProps.data.prototype.uuid !== PRODUCT_PROTOTYPES.PROMO &&
            slotProps.data.prototype.uuid !== PRODUCT_PROTOTYPES.MEMBER"
              >
              </Button>
            </router-link>
            <Button
                v-if="canDuplicate(slotProps)"
                size="small"
                icon="pi pi-clone"
                class="p-button-warning"
                style="margin-right: 0.5em"
                title="Dupliquer"
                @click="setUuidAndOpenModal(slotProps.data.uuid)"
            >
            </Button>
          </template>
        </Column>
      </div>
      <template #empty>Aucun résultat trouvé.</template>
    </DataTable>
    <DuplicateProductModal :product-uuid="productUuid" :duplicate-product-modal-id="duplicateProductModalId"></DuplicateProductModal>
  </div>
</template>
<script lang="ts" setup>
import {ref, onMounted, watch, onBeforeMount} from "vue";
import { useRouter } from "vue-router";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { productService } from "@/_services/product/product";
import { getPaginatedSupplierForDropDown } from "@/_services/supplier/supplier";
import { formatStatus } from "@/_helpers/stringManipulations";
import { IMasterProduct } from "@/models/product/IMasterProduct";
import swal from "@/_helpers/swal";
import {PRODUCT_PROTOTYPES} from "@/constants/product/properties";
import {SUPPLIER_UUIDS} from "@/_services/supplier/supplier";
import { IPatchProductStatusByBatchPlayload } from "@/models/product/IMasterProduct";
import DuplicateProductModal from "@/components/modal/product/DuplicateProductModal.vue";
import * as sweetalert2 from "sweetalert2";

const router = useRouter();


const isLoading = ref<boolean>(true);
const isSelectAllBtnChecked = ref<boolean>(false);
const masterProducts = Array<IMasterProduct>();
const tableData = ref<Array<IMasterProduct>>(masterProducts);
const rows = ref<number>(10);
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const selectedStatusOptionForBatchUpdate = ref<boolean|null>(null);
const selectedOptionSupplier = ref<string|undefined>(undefined);
const selectedProducts = ref(Array<IMasterProduct>());
const productsOfCurrentPage = ref(Array<IMasterProduct>());
const totalSelectedProducts = ref<number>(0);
const localStorageKey = "adminMasterProductBatchStatus";

onBeforeMount(() => {
    initLocalStorageData();
});

onMounted(async () => {
  await populateDatatable();
});

const initLocalStorageData = () => {
    if (localStorage.getItem(localStorageKey)) {
        localStorage.removeItem(localStorageKey);
    }
}

const onFilterDt = () => {
    rows.value = 10;
    page.value = 1;
    currentPage.value = 0;
    populateDatatable();
};
const onClearInputFilter = () => {
    if (criteria.value === "") {
        rows.value = 10;
        page.value = 1;
        currentPage.value = 0;
        populateDatatable();
    }
};

watch(selectedOptionSupplier, () => {
    populateDatatable();
});

async function populateDatatable() {
    isLoading.value = true;
    const [loadingDt, totalRecordsDt, tableDataDt] = await productService.fetchProduct(rows.value, page.value, criteria.value, selectedOptionSupplier.value);
    isLoading.value = loadingDt;
    totalRecords.value = totalRecordsDt;
    tableData.value = tableDataDt;
    productsOfCurrentPage.value = tableData.value;
    
    return [isLoading.value, totalRecords.value, tableData.value]
}
const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    await clearSelectedProducts();
    await populateDatatable();
};
const productUuid = ref<string>("");
const duplicateProductModalId = "duplicateProductModal";
const setUuidAndOpenModal = (uuid: string) => {
    productUuid.value = uuid;
    const duplicateProductFormModalElement:HTMLDialogElement | null = document.querySelector(`#${duplicateProductModalId}`);
    if (duplicateProductFormModalElement) {
        duplicateProductFormModalElement.showModal();
    }
};

const canDuplicate = (slotProps) => {
    const prototypeUuid = slotProps.data.prototype.uuid;
    const supplierUuid = slotProps.data.supplier.uuid;
    const allowedProductTypes = [PRODUCT_PROTOTYPES.TICKET, PRODUCT_PROTOTYPES.PHYSICAL];
    const restrictedSuppliers = [
        SUPPLIER_UUIDS.JACKPOT,
        SUPPLIER_UUIDS.PRESS,
        SUPPLIER_UUIDS.PROMO_PARC,
        SUPPLIER_UUIDS.CINE_CHEQUE,
        SUPPLIER_UUIDS.OGLOBA
    ];

    return allowedProductTypes.includes(prototypeUuid) && !restrictedSuppliers.includes(supplierUuid);
};

const onDelete = (data: IMasterProduct) => {
  swal
    .confirm("Êtes vous sur de vouloir archiver le produit ?")
    .then((result) => {
      if (result.isConfirmed) {
        productService.deleteMasterProduct(data.uuid).then(() => {
          swal.success("Archivé !", "Vous venez d'archiver le produit");
          refreshDatatable();
        });
      }
    });
};

const refreshDatatable = () => {
  populateDatatable();
};

async function searchSuppliers({ search, page, hasNextPage }) {
    const [totalSuppliersRecordsForDropDown, suppliersForDropDown] = await getPaginatedSupplierForDropDown(5, page, search, true);
    const hasItems = suppliersForDropDown.length > 0;
    if (hasItems && page !== totalSuppliersRecordsForDropDown) {
        hasNextPage();
    }
    
   return suppliersForDropDown;
}

const onSelectAllChange = async (event): Promise<void> => {
    showSpinner();
    if (true === event.checked) {
        isSelectAllBtnChecked.value = true;
        selectedProducts.value = productsOfCurrentPage.value;
        totalSelectedProducts.value = productsOfCurrentPage.value.length;
    } else {
        await clearSelectedProducts();
    }
    hideSpinner();
};

const clearSelectedProducts = async (): Promise<void> => {
    isSelectAllBtnChecked.value = false;
    selectedProducts.value = [];
    totalSelectedProducts.value = 0;
};

const onRowSelect = () => {
    if (totalSelectedProducts.value >= 0) {
        totalSelectedProducts.value++;
        if (totalSelectedProducts.value === productsOfCurrentPage.value.length) {
            isSelectAllBtnChecked.value = true;
        }
    }
}

const onRowUnselect = () => {
    if (totalSelectedProducts.value > 0) {
        totalSelectedProducts.value--;
        isSelectAllBtnChecked.value = false;
    }
}

const onSubmit = async (formData, formNode) => {
    try {
        const selectedProductsUuids = selectedProducts.value.map((product: IMasterProduct) => product.uuid);
        const payload: IPatchProductStatusByBatchPlayload = {
            isActive: formData.selected_status_for_batch_update,
            masterProductsUuids: selectedProductsUuids,
        }
        let action = payload.isActive ? 'activer' : 'désactiver';
        const warningMessage = `Êtes-vous sûr de vouloir ${action} les ${totalSelectedProducts.value} produits et variants associés ?`;
        swal.confirm(warningMessage, "Annuler")
            .then((result) =>  {
                if (result.isConfirmed) {
                    showSpinner();
                    productService.updateProductsStatusByBatch(payload).then(() => {
                        swal.success("", 'Les statuts ont bien été changés !').then(() => {
                            hideSpinner();
                            isSelectAllBtnChecked.value = false;
                            clearSelectedProducts();
                            populateDatatable();
                        });
                    });
                }
            });
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

const showSpinner = () => {
    isLoading.value = true;
}

const hideSpinner = () => {
    isLoading.value = false;
}

const navigateToAddProduct = () => {
    router.push('/admin/addProduct');
}
</script>
<style scoped lang="scss">

select {
  @apply font-normal;
}
.card-body {
  @apply bg-white;
}




.addProductLink {
  @apply inline-flex items-center justify-center rounded-full py-2 px-4 ml-1 text-sm font-semibold
  focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white
  hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600;
}
.search-container {
  justify-content: space-between;
  padding: 10px;
  .pi {
      z-index: 2;
   }
  .p-inputtext {
    padding: 15px;
    padding-left: 30px;
    width: 100%;
    max-width: 300px;
    font-weight: normal;
    position: relative;
    
    z-index: 1;
    border: 1px solid #656565;
  }
}
</style>
